<app-page>
  <wallet></wallet>
</app-page>
